import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Polyfills that are currently not configured via babel
import 'whatwg-fetch'
import 'document-register-element/build/document-register-element'
import 'intl'

import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './mixins/import'
import { register as registerCustomElements } from './helper/customElementsHelper'
import * as Store from './store'
import vueCustomElement from 'vue-custom-element'
import { createProvider } from './apollo'

import Config from '../config/sebstauskunft'
import { globalStoreConfig } from '@/store/config'
import { storeConfig } from '@/store/config/selbstauskunft'

import ErrorView from './components/generic/MessageView/ErrorModal'
import RestrictedLogInWrapper from './components/process/generic/Authentication/Login/RestrictedLogin/RestrictedLogInWrapper'
import DynSlot from '@/components/generic/DynSlot'
import Tooltip from '@/components/generic/Tooltip'
import MnpOutStatus from './components/process/generic/Mnp/MnpOutStatus/ShowMnpOutStatus'
import GDPRDataWrapper from '@/components/process/generic/GDPRData/GDPRDataWrapper'
import ConsumptionsWithoutTariffsWrapper from './components/process/generic/Tariff/selbstauskunft/ConsumptionsWithoutTariffsWrapper'
import ConsumptionItemProgress from './components/process/generic/Consumption/bild/ConsumptionItemProgress'
import CurrentMsisdn from './components/process/generic/Customer/Msisdn/CurrentMsisdn'
import Msisdn from './components/process/generic/Customer/Msisdn/Msisdn'
import LogOutLink from './components/process/generic/Authentication/LogOut/LogOutLink'
import EmailVerificationModal from './components/process/generic/Email/EmailVerification/EmailVerificationModal'
import ProductInformationSheetsWrapper from './components/process/generic/ProductInformationSheet/ProductInformationSheetsWrapper'
import ProductInformationItemRecent
  from './components/process/generic/ProductInformationSheet/ProductInformationItemRecent'
import CustomerDocList from '@/components/process/generic/ItemisedBills/selbstauskunft/ConsumerDocumentList/ConsumerDocumentListOverviewFixed'
import OptionsWrapper from '@/components/process/generic/Tariff/generic/ACROption/ACROptionWrapper'
import PersonalDataWrapper from '@/components/process/generic/PersonalData/puremobile/PersonalDataWrapper'
import EmailConfirmationWrapper from '@/components/process/generic/Email/EmailConfirmation/EmailConfirmationWrapper'
import SendVerificationMail from '@/components/process/generic/Email/EmailVerification/SendVerificationMail'
import CancellationWrapper from '@/components/process/generic/Cancellation/CancellationWrapper'
import ContractSummary from '@/components/process/generic/Tariff/generic/ContractSummary'

const API_BASE_URL = process.env.VUE_APP_SELBSTAUSKUNFT_API_BASE_URL || process.env.VUE_APP_API_BASE_URL
const GRAPHQL_HTTP = process.env.VUE_APP_SELBSTAUSKUNFT_GRAPHQL_HTTP || process.env.VUE_APP_GRAPHQL_HTTP

Vue.use(Config, {
  apiUrl: API_BASE_URL
})

const store = Store.createStore({
  ...globalStoreConfig,
  ...storeConfig
})
store.commit('selectBrand', 'puremobile')
store.commit('selectRetailerId', '40006311')
store.commit('selectType', 'DELIVERY')
// ggf. hier auf ENVs gehen, wenn nötig -> process.env.SELSTAUSKUNFT_CLIENT_ID + SELSTAUSKUNFT_CLIENT_SECRET
store.commit('selectClient', { id: 'puremobile', secret: 'puremobile' })
store.commit('selectBaseUrl', API_BASE_URL)

const apolloProvider = createProvider(store, {
  autoLogoutMessage: 'Es ist ein technischer Fehler aufgetreten. Sie wurden zur Sicherheit abgemeldet. Bitte melden Sie sich erneut an. Sollten die Probleme bestehen bleiben, so wenden Sie sich an die Hotline.',
  httpEndpoint: GRAPHQL_HTTP,
  restEndpoint: API_BASE_URL
})

Vue.component('dyn-slot', DynSlot)

Vue.config.productionTip = false

Vue.config.ignoredElements = [
  // Use a `RegExp` to ignore all elements that start with "ion-"
  // 2.5+ only
  // /^ion-/
]

Vue.config.productionTip = false

Vue.use(vueCustomElement)
Vue.component('dyn-slot', DynSlot)
// There are 2 Variants of presenting Consumptions: Progress Bar and Plain Text
// To change it, register the matching component as `ConsumptionItem`
Vue.component('ConsumptionItem', ConsumptionItemProgress)
Vue.component('ProductInformationItem', ProductInformationItemRecent)

registerCustomElements({
  // generics
  'app-tooltip': Tooltip,
  'app-msisdn': Msisdn,
  'app-current-msisdn': CurrentMsisdn,
  // processes
  'app-error-view': ErrorView,
  'app-send-verification-mail': SendVerificationMail,
  'app-email-verification-modal': EmailVerificationModal,
  'app-login-wrapper': RestrictedLogInWrapper,
  'app-logout': LogOutLink,
  'app-mnp-out-status': MnpOutStatus,
  'app-gdpr-data-wrapper': GDPRDataWrapper,
  'app-consumption': ConsumptionsWithoutTariffsWrapper,
  'app-product-information-sheets': ProductInformationSheetsWrapper,
  'app-customer-doc-list': CustomerDocList,
  'app-options-wrapper': OptionsWrapper,
  'app-change-personal-data-wrapper': PersonalDataWrapper,
  'app-email-confirmation-wrapper': EmailConfirmationWrapper,
  'app-cancellation-wrapper': CancellationWrapper,
  'app-contract-summary': ContractSummary
}, store, apolloProvider)
